"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchTypes = exports.WSSearch = void 0;
var _react = _interopRequireWildcard(require("react"));
var _searchIcon = _interopRequireDefault(require("../../../assets/teacher/images/worksheets/search-icon.svg"));
var _crossIcon = _interopRequireDefault(require("../../../assets/teacher/images/worksheets/cross-icon.svg"));
var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));
var _reactDebounceInput = require("react-debounce-input");
var _searchDropdownFallback = require("apps/teacher/fallbackComponents/worksheet/searchDropdownFallback");
var PrintableWorksheetsApi = _interopRequireWildcard(require("../../api"));
var _state = require("printableWorksheets/state");
var _OutsideClickHandler = _interopRequireDefault(require("../OutsideClickHandler"));
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _printableWorksheets = require("printableWorksheets");
var _AppMediaProvider = require("../../../baseStyles/AppMediaProvider");
var _searchiIcon = _interopRequireDefault(require("./searchi-icon2.svg"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _InvisibleInput = _interopRequireDefault(require("../../../teacherDashboard/atoms/InvisibleInput"));
var _PDFViewer = _interopRequireDefault(require("../../../teacherDashboard/teacher/components/common/PDFViewer"));
require("./styles.scss");
require("../../../assets/teacher/stylesheets/teachers/pdf_viewer.scss");
var _common = require("apps/teacher/config/common");
var _wsPreview = _interopRequireDefault(require("./wsPreview"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // @ts-nocheck
// import { sendErrorToSentry } from 'apps/teacher/components/teacher_app_container/ErrorBoundary/sendErrorToSentry';
var searchTypes = exports.searchTypes = {
  TRENDING: 'Trending searches',
  RECENT: 'Recent searches',
  BEST_MATCHES: 'Best matches'
};

/**
 * This component renders the Search input and search dropdown on Worksheet page
 *
 * @property {Boolean} defaultSearch To show or hide extended search input
 * @property {String} subjectCode current subject selected
 * @property {Function} toggleDefaultSearch function to show or hide extended search input
 * @property {String} worksheetSearchValue stores values which is entered into search input
 * @property {String} gradeCode current grade code
 * @property {String} userId contains teacher id
 *
 */

var WSSearch = exports.WSSearch = function WSSearch(_ref) {
  var _ref$defaultSearch = _ref.defaultSearch,
    defaultSearch = _ref$defaultSearch === void 0 ? false : _ref$defaultSearch,
    _ref$subjectCode = _ref.subjectCode,
    subjectCode = _ref$subjectCode === void 0 ? "math" : _ref$subjectCode,
    _ref$toggleDefaultSea = _ref.toggleDefaultSearch,
    toggleDefaultSearch = _ref$toggleDefaultSea === void 0 ? function () {} : _ref$toggleDefaultSea,
    _ref$worksheetSearchV = _ref.worksheetSearchValue,
    worksheetSearchValue = _ref$worksheetSearchV === void 0 ? '' : _ref$worksheetSearchV,
    _ref$gradeCode = _ref.gradeCode,
    gradeCode = _ref$gradeCode === void 0 ? "" : _ref$gradeCode,
    _ref$userId = _ref.userId,
    userId = _ref$userId === void 0 ? null : _ref$userId,
    _ref$searchPlaceholde = _ref.searchPlaceholder,
    searchPlaceholder = _ref$searchPlaceholde === void 0 ? null : _ref$searchPlaceholde;
  // const dispatch = useDispatch();

  var _useState = (0, _react.useState)(worksheetSearchValue),
    _useState2 = _slicedToArray(_useState, 2),
    worksheetName = _useState2[0],
    setWorksheetName = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    searchResults = _useState4[0],
    setSearchResults = _useState4[1];
  var _useState5 = (0, _react.useState)(searchTypes.RECENT),
    _useState6 = _slicedToArray(_useState5, 2),
    searchType = _useState6[0],
    setSearchType = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedPdf = _useState8[0],
    setSelectedPdf = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    trendingWorksheet = _useState0[0],
    setTrendingWorksheet = _useState0[1];
  var _useState1 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState1, 2),
    initialLoading = _useState10[0],
    setInitialLoading = _useState10[1];
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    activeGrade = _usePrintableWorkshee.activeGrade,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    downloadedWorksheets = _usePrintableWorkshee.downloadedWorksheets,
    activeBreadcrumb = _usePrintableWorkshee.activeBreadcrumb,
    setFilteredSearchTerm = _usePrintableWorkshee.setFilteredSearchTerm,
    setActiveScreen = _usePrintableWorkshee.setActiveScreen,
    setSearchScreenData = _usePrintableWorkshee.setSearchScreenData,
    setDownloadedWorksheets = _usePrintableWorkshee.setDownloadedWorksheets,
    setDownloadCount = _usePrintableWorkshee.setDownloadCount;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    currentDevice = _useAppMediaProvider.currentDevice,
    isDesktop = _useAppMediaProvider.isDesktop;
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    switchToIcon = _useState12[0],
    toggleSwitchToIcon = _useState12[1];
  var _useAppMediaProvider2 = (0, _AppMediaProvider.useAppMediaProvider)(),
    isMobile = _useAppMediaProvider2.isMobile;
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showWorksheetPreview = _useState14[0],
    setShowWorksheetPreview = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showUnlockButton = _useState16[0],
    setShowUnlockButton = _useState16[1];
  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    worksheetDetail = _useState18[0],
    setWorksheetDetail = _useState18[1];
  (0, _react.useEffect)(function () {
    if (isMobile) {
      toggleSwitchToIcon(true);
    } else {
      toggleSwitchToIcon(false);
    }
  }, [currentDevice]);
  (0, _react.useEffect)(function () {
    if (userId) {
      if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
        getTrendingWorksheets();
      } else {
        checkForFirstTimeClick([]);
      }
    }
  }, [userId]);
  (0, _react.useEffect)(function () {
    var _document$getElements;
    var wsRailsContainerDiv = (_document$getElements = document.getElementsByClassName('ws-rails-container')) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];
    if (wsRailsContainerDiv) {
      if (!defaultSearch && !initialLoading && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0) {
        wsRailsContainerDiv.style.pointerEvents = 'none';
      } else {
        wsRailsContainerDiv.style.pointerEvents = 'all';
      }
    }
  }, [defaultSearch, initialLoading, searchResults]);
  var checkForFirstTimeClick = function checkForFirstTimeClick() {
    var trendingWsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var alreadyFirstTime = localStorage.getItem("First_Time_Click_On_Search" + userId + subjectCode + gradeCode);
    if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      if (!alreadyFirstTime) {
        localStorage.setItem("First_Time_Click_On_Search" + userId + subjectCode + gradeCode, true);
        setSearchType(searchTypes.TRENDING);
        setSearchResults(trendingWsList);
        setInitialLoading(false);
      } else {
        getRecentUserSearches(trendingWsList);
      }
    }
  };
  var _onDownload = function onDownload(worksheetDetails) {
    if (worksheetDetails.id && userId) {
      // GlobalSpinner.show();
      fetch(worksheetDetails.pdf_url, {
        credentials: 'omit'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        // GlobalSpinner.hide();
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = worksheetDetails.title;
        a.target = '_system';
        a.click();
        a.remove();
        if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
          PrintableWorksheetsApi.postSaveUserDownload({
            userId: userId,
            params: {
              entity_id: worksheetDetails.id,
              entity_type: 'SearchContent'
            },
            callback: function callback() {
              showFlashMessage('Worksheet downloaded successfully', 'success');
              if (!downloadedWorksheets.find(function (ws) {
                return ws.id === worksheetDetails.id;
              })) {
                setDownloadedWorksheets(function (dws) {
                  return [].concat(_toConsumableArray(dws), [worksheetDetails]);
                });
                setDownloadCount(function (downloadCount) {
                  return downloadCount + 1;
                });
              }
              if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
                var _window;
                (_window = window) === null || _window === void 0 || _window.dispatchEvent(new CustomEvent('download-worksheets-update'));
                var props = {
                  worksheetName: worksheetDetails.title,
                  worksheetGrade: gradeCode.toLowerCase(),
                  worksheetCategory: "",
                  worksheetSubcategory: "",
                  from: selectedPdf ? "Preview" : "Worksheet Listing Page"
                };
                _events["default"].downloadedWorksheet(props);
              }
            }
          });
        }
      })["catch"](function (e) {
        // sendErrorToSentry(new Error("Worksheet download failed"), worksheetDetails)
      });
    }
  };
  var onSearchInputChange = function onSearchInputChange(e) {
    setWorksheetName(e.target.value);
    if (e.target.value !== "") {
      // getSearchResults api returns empty in case of single character
      if (e.target.value.length > 1) {
        getSearchResults(e.target.value);
      }
    } else {
      setSearchType(searchTypes.TRENDING);
      setSearchResults(trendingWorksheet);
    }
  };
  var getSearchResults = function getSearchResults() {
    var _activeBreadcrumb$;
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    setSearchType(searchTypes.BEST_MATCHES);
    PrintableWorksheetsApi.getSearchResults({
      params: {
        query: query,
        grade: gradeCode,
        subject: (activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb$ = activeBreadcrumb[0]) === null || _activeBreadcrumb$ === void 0 ? void 0 : _activeBreadcrumb$.title) === "Math" ? _state.SubjectCodes.MATH : _state.SubjectCodes.ELA,
        page_number: 0,
        page_size: 10
      },
      callback: function callback(callbackData) {
        var _callbackData$searche;
        setSearchResults(callbackData.searches);
        var props = {
          searchTerm: query,
          countOfSearchResults: (_callbackData$searche = callbackData.searches) === null || _callbackData$searche === void 0 ? void 0 : _callbackData$searche.length,
          grade: onboardingGrade
        };
        _events["default"].startedPrintablesSearch(props);
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to getSearchResults on search worksheet screen"), { error: err })
      }
    });
  };
  var postUserSearches = function postUserSearches(_ref2) {
    var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "" : _ref2$type,
      _ref2$searchTerm = _ref2.searchTerm,
      searchTerm = _ref2$searchTerm === void 0 ? "" : _ref2$searchTerm,
      _ref2$worksheetId = _ref2.worksheetId,
      worksheetId = _ref2$worksheetId === void 0 ? "" : _ref2$worksheetId;
    var params = {};
    if (type === "SEARCH") {
      params = {
        entity_type: "search",
        search_term: searchTerm,
        subject: subjectCode,
        grade: gradeCode
      };
    } else {
      params = {
        entity_type: "worksheet_select",
        entity_id: worksheetId,
        subject: subjectCode,
        grade: gradeCode
      };
    }
    PrintableWorksheetsApi.postUserSearches({
      userId: userId,
      params: params,
      callback: function callback(res) {
        var _res$search_entity;
        setFilteredSearchTerm(res === null || res === void 0 || (_res$search_entity = res.search_entity) === null || _res$search_entity === void 0 ? void 0 : _res$search_entity.search_term);
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to postUserSearches on search worksheet screen"), { error: err })
      }
    });
  };
  var getRecentUserSearches = function getRecentUserSearches() {
    var trendingWsList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    PrintableWorksheetsApi.getRecentUserSearches({
      userId: userId,
      params: {
        subject: subjectCode,
        grade: gradeCode,
        page_number: 0,
        page_size: 10
      },
      callback: function callback(callbackData) {
        if (callbackData.length > 0) {
          getSearchWorksheetByIds(callbackData);
        } else {
          setSearchType(searchTypes.TRENDING);
          setSearchResults(trendingWsList);
          setInitialLoading(false);
        }
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to getRecentUserSearches on search worksheet screen"), { error: err })
      }
    });
  };
  var getWorksheetIds = function getWorksheetIds(result) {
    var ids = [];
    result.map(function (item) {
      var _item$search_entity;
      if ((item === null || item === void 0 || (_item$search_entity = item.search_entity) === null || _item$search_entity === void 0 ? void 0 : _item$search_entity.entity_type) === 'WORKSHEET_SELECT') {
        ids.push(item.search_entity.entity_id);
      }
    });
    return ids;
  };
  var modifyRecentSearches = function modifyRecentSearches(_ref3) {
    var data = _ref3.data,
      _ref3$worksheetList = _ref3.worksheetList,
      worksheetList = _ref3$worksheetList === void 0 ? [] : _ref3$worksheetList;
    var recentSearches = data.map(function (item) {
      var _item$search_entity2;
      var modifiedSearch = {};
      if ((item === null || item === void 0 || (_item$search_entity2 = item.search_entity) === null || _item$search_entity2 === void 0 ? void 0 : _item$search_entity2.entity_type) === 'WORKSHEET_SELECT') {
        modifiedSearch = worksheetList.find(function (worksheet) {
          return worksheet.id === item.search_entity.entity_id;
        });
      } else {
        modifiedSearch = _objectSpread(_objectSpread({}, item.search_entity), {}, {
          title: item.search_entity.search_term
        });
      }
      return modifiedSearch;
    });
    return recentSearches;
  };
  var getSearchWorksheetByIds = function getSearchWorksheetByIds(data) {
    var ids = getWorksheetIds(data);
    if (ids.length !== 0) {
      PrintableWorksheetsApi.getWorksheetsByIds({
        params: {
          ids: getWorksheetIds(data)
        },
        callback: function callback(callbackData) {
          setSearchResults(modifyRecentSearches({
            data: data,
            worksheetList: callbackData.searches
          }));
          setInitialLoading(false);
        },
        errorCallback: function errorCallback(err) {
          // sendErrorToSentry(new Error("failed to getSearchWorksheetByIds on search worksheet screen"), { error: err })
        }
      });
    } else {
      setSearchResults(modifyRecentSearches({
        data: data,
        worksheetList: []
      }));
      setInitialLoading(false);
    }
  };
  var getTrendingWorksheets = function getTrendingWorksheets() {
    PrintableWorksheetsApi.getTrendingWorksheets({
      params: {
        grade: gradeCode,
        subject: subjectCode
      },
      callback: function callback(callbackData) {
        setTrendingWorksheet(callbackData.searches);
        checkForFirstTimeClick(callbackData.searches);
      },
      errorCallback: function errorCallback(err) {
        // sendErrorToSentry(new Error("failed to getTrendingWorksheet on search worksheet screen"), { error: err })
      }
    });
  };
  var searchOnClickHandler = function searchOnClickHandler() {
    toggleDefaultSearch(false);
    fireViewedWorksheetSearchDropdown();
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter' && e.target.value.length > 0) {
      fireViewedWorksheetSearchResultsPage();
      postUserSearches({
        type: "SEARCH",
        searchTerm: e.target.value
      });
      toggleDefaultSearch(true);
      setWorksheetName(e.target.value);
      goToSearchWorksheetScreen(e.target.value);
    }
  };
  var individualSearchClickHandler = function individualSearchClickHandler(item, index) {
    fireInteractedWorksheetSearchDropdown(index);
    fireViewedWorksheetSearchResultsPage();
    toggleDefaultSearch(true);
    if (item.entity_type === "SEARCH") {
      setWorksheetName(item.title);
      goToSearchWorksheetScreen(item.title);
      postUserSearches({
        type: "SEARCH",
        searchTerm: item.title
      });
    } else {
      postUserSearches({
        type: "WORKSHEET_SELECT",
        worksheetId: item.id
      });
      worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? setSelectedPdf(item) : onSearchClick(item);
      // setSelectedPdf(item);
    }
  };
  var onSearchClick = function onSearchClick(wsDetail) {
    if (isDesktop) {
      setWorksheetDetail(wsDetail);
      setShowWorksheetPreview(true);
      window.parent.triggerIsFlutterHeaderClickDisabled && window.parent.triggerIsFlutterHeaderClickDisabled();
      if (!(0, _common.canDownloadWs)()) {
        setShowUnlockButton(true);
      }

      /// if preview popup is opened then unset all overflow properties in parent. (Safari/Firefox browser issue fix)
      var worksheetsRightDiv = window.document.getElementById('ws-right-div');
      worksheetsRightDiv.style.overflowX = 'unset';
      worksheetsRightDiv.style.overflowY = 'unset';
    } else {
      var _item;
      window.open((_item = item) === null || _item === void 0 ? void 0 : _item.pdf_url);
      _events["default"].downloadedWorksheetB2c({
        worksheetName: wsDetail.title,
        worksheetCode: wsDetail.code
      });
    }
  };
  (0, _react.useEffect)(function () {
    var worksheetsRightDiv = window.document.getElementById('ws-right-div');
    var wsPreview = window.document.getElementById('ws-preview-wrapper');
    /// if preview popup is opened then no overflow property should set. 
    if (selectedPdf) {
      if (worksheetsRightDiv && !wsPreview) {
        worksheetsRightDiv.style.overflowX = 'visible';
        worksheetsRightDiv.style.overflowY = 'visible';
      }
    } else {
      if (worksheetsRightDiv && !wsPreview) {
        worksheetsRightDiv.style.overflowY = 'auto';
        worksheetsRightDiv.style.overflowX = 'hidden';
      }
    }
  }, [selectedPdf]);
  var goToSearchWorksheetScreen = function goToSearchWorksheetScreen(title) {
    var _activeBreadcrumb$2;
    // dispatch({ type: ReducerConstants.SET_WORKSHEET_VALUE, payload: title });
    var params = {
      query: title,
      grade: gradeCode,
      subject: (activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb$2 = activeBreadcrumb[0]) === null || _activeBreadcrumb$2 === void 0 ? void 0 : _activeBreadcrumb$2.title) === "Math" ? _state.SubjectCodes.MATH : _state.SubjectCodes.ELA,
      page_number: 0,
      page_size: 1000
    };
    setSearchScreenData({
      params: params,
      title: title,
      from: 'SEARCH'
    });
    setActiveScreen(_state.PRINTABLE_WORKSHEET_SCREENS.SEARCH);
  };
  var fireInteractedWorksheetSearchDropdown = function fireInteractedWorksheetSearchDropdown(index) {
    if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      var props = {
        clickedOn: "Search Result ".concat(index + 1)
      };
      _events["default"].interactedWorksheetSearchDropdown(props);
    } else {
      var _props = {
        searchTerm: worksheetName,
        searchResultSelected: "Search Result ".concat(index + 1),
        grade: activeGrade
      };
      _events["default"].selectedPrintablesSearch(_props);
    }
  };
  var fireViewedWorksheetSearchDropdown = function fireViewedWorksheetSearchDropdown() {
    _events["default"].viewedWorksheetSearchDropdown();
  };
  var fireViewedWorksheetSearchResultsPage = function fireViewedWorksheetSearchResultsPage() {
    _events["default"].viewedWorksheetSearchResultsPage();
  };
  var crossOnClickHandler = function crossOnClickHandler() {
    closeViewForSearch();
    setWorksheetName("");
  };
  var closeViewForSearch = function closeViewForSearch() {
    toggleDefaultSearch(true);
    setSearchResults([]);
    toggleSwitchToIcon(isMobile ? true : false);
    $('.worksheet-mobile-options').show();
  };
  var showViewForSearch = function showViewForSearch() {
    toggleDefaultSearch(false);
    toggleSwitchToIcon(false);
    $('.worksheet-mobile-options').hide();
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, showWorksheetPreview && /*#__PURE__*/_react["default"].createElement(_wsPreview["default"], {
    worksheetDetails: worksheetDetail,
    setShowWorksheetPreview: setShowWorksheetPreview,
    showWorksheetPreview: showWorksheetPreview,
    showUnlockButton: showUnlockButton
  }), /*#__PURE__*/_react["default"].createElement(_OutsideClickHandler["default"], {
    outsideClickHandler: closeViewForSearch,
    "data-sentry-element": "OutsideClickHandler",
    "data-sentry-source-file": "wsSearch.tsx"
  }, switchToIcon && isMobile ? (/*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement("div", {
    className: "search-icon-container",
    onClick: function onClick() {
      showViewForSearch();
      var elem = document.getElementById('ws-header');
      elem.scrollIntoView();
    }
  }, /*#__PURE__*/_react["default"].createElement(_searchiIcon["default"], null)), document.getElementById("searchIconPortal"))) : /*#__PURE__*/_react["default"].createElement("div", {
    "data-test-id": "worksheet-search-container",
    className: "search-container ".concat(!defaultSearch ? "increase-width" : ""),
    id: "printables-search-icon"
  }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
    id: "input-search",
    type: "text",
    className: !defaultSearch ? "increase-width" : "",
    placeholder: searchPlaceholder ? searchPlaceholder : 'Search ' + subjectCode + ' worksheets...',
    onClick: searchOnClickHandler,
    autoComplete: "off",
    onChange: function onChange(e) {
      return onSearchInputChange(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    value: worksheetName,
    debounceTimeout: 400
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "input-search"
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: "ws-search-icon"
  }, /*#__PURE__*/_react["default"].createElement(_searchIcon["default"], null)), !defaultSearch && /*#__PURE__*/_react["default"].createElement("i", {
    className: "ws-cross-icon"
  }, /*#__PURE__*/_react["default"].createElement(_crossIcon["default"], {
    onClick: crossOnClickHandler
  }))), !defaultSearch && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0 && (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD || !initialLoading) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-dropdown",
    ref: function ref(_ref4) {
      if (_ref4 && worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD) {
        var elementDetails = _ref4.getBoundingClientRect();
        _ref4.style.maxHeight = "calc(100vh - ".concat(elementDetails.top - 72, "px)");
      }
    }
  }, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-results"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-result-type"
  }, searchType), searchResults.map(function (item, index) {
    var _item$search_nodes_ti;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: item === null || item === void 0 ? void 0 : item.id,
      className: "search-result",
      onClick: function onClick() {
        individualSearchClickHandler(item, index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactHighlightWords["default"], {
      className: "title",
      highlightClassName: "highlight-class",
      searchWords: [worksheetName],
      autoEscape: true,
      textToHighlight: item === null || item === void 0 ? void 0 : item.title
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "tree-name"
    }, item.entity_type !== 'SEARCH' && /*#__PURE__*/_react["default"].createElement("span", null, " in ", item === null || item === void 0 || (_item$search_nodes_ti = item.search_nodes_titles) === null || _item$search_nodes_ti === void 0 ? void 0 : _item$search_nodes_ti.join('/ '))));
  })) : worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD && isMobile ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-search-result"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "heading"
  }, "No result found for this grade"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "body"
  }, "We couldn\u2019t understand what you mean, try searching something else."))), initialLoading && !defaultSearch && /*#__PURE__*/_react["default"].createElement(_searchDropdownFallback.SearchDropdownFallback, null)), selectedPdf && selectedPdf.pdf_url && /*#__PURE__*/_react["default"].createElement(_PDFViewer["default"], {
    title: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.title,
    subtitle: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.meta_description,
    file: selectedPdf === null || selectedPdf === void 0 ? void 0 : selectedPdf.pdf_url,
    onBack: function onBack() {
      return setSelectedPdf(null);
    },
    onDownload: function onDownload() {
      return _onDownload(selectedPdf);
    },
    showSave: false,
    isMobileView: true
  }), /*#__PURE__*/_react["default"].createElement(_InvisibleInput["default"], {
    "data-sentry-element": "InvisibleInput",
    "data-sentry-source-file": "wsSearch.tsx"
  }));
};